import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import getFlightWeather from './actions/getFlightWeather'
import resetFlightWeather from "./actions/resetFlightWeather";
import FlightWeather from './components/index'

const mapStateToProps = (state) => {
    return ({
        error: state.error.message,
        data: state.briefing.weather.data,
        isLoading: state.briefing.weather.isLoading
    })
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({
        getFlightWeather,
        resetFlightWeather
    }, dispatch)
})

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(FlightWeather))



// WEBPACK FOOTER //
// ./src/screens/briefing/weather/index.js